function setPermitValidated(state, value) {
    state.permitValidated = value;
}

function setPermitNumber(state, permitNumber) {
    state.permitNumber = permitNumber;
}

function setBusinessName(state, businessName) {
    state.businessName = businessName;
}

function setContactPerson(state, contactPerson) {
    state.contactPerson = contactPerson;
}

function setEmail(state, email) {
    state.email = email;
}

function setPermitYear(state, permitYear) {
    state.permitYear = permitYear;
}

function setPermitYearsLoading(state, value) {
    state.permitYearsLoading = value;
}

function setPermitYears(state, permitYears) {
    state.permitYears = permitYears;
}

function addFacilityUsage(state, facilityUsage) {
    state.facilityUsages.push(facilityUsage);
}

function removeFacilityUsage(state, index) {
    state.facilityUsages.splice(index, 1);
}

function updateFacilityUsage(state, { facilityUsage, index }) {
    state.facilityUsages[index] = facilityUsage;
}

function setFacilityUsages(state, facilityUsages) {
    facilityUsages.forEach(facilityUsage => {
        if (facilityUsage.feePaid !== undefined) {
            facilityUsage.fee = facilityUsage.feePaid;
        }
    });

    state.facilityUsages = facilityUsages;
}


function setActivitiesLoading(state, value) {
    state.activitiesLoading = value;
}

function setActivities(state, activities) {
    state.activities = activities;
}

function setAreasLoading(state, value) {
    state.areasLoading = value;
}

function setAreas(state, areas) {
    state.areas = areas;
}

function setFacilitiesLoading(state, value) {
    state.facilitiesLoading = value;
}

function setFacilities(state, facilities) {
    state.facilities = facilities;
}

function setPersistentStorageChecked(state, value) {
    state.persistentStorageChecked = value;
}

function setPermitNumberServerValidationError(state, value) {
    state.permitNumberServerValidationError = value;
}

function setPermitNumberServerValidationErrorMessage(state, message) {
    state.permitNumberServerValidationErrorMessage = message;
}

function setShouldAutosave(state, value) {
    state.shouldAutosave = value;
}

function setPendingAsyncRequest(state, value) {
    state.pendingAsyncRequest = value;
}

function setPerformingInitialLoad(state, value) {
    state.performingInitialLoad = value;
}

function setZeroFacilityUsagesReport(state, value) {
    state.zeroFacilityUsagesReport = value;
}

function setIsZeroFacilityUsagesReportSubmission(state, value) {
    state.isZeroFacilityUsagesReportSubmission = value;
}

export default {
    setPermitValidated,
    setBusinessName,
    setContactPerson,
    setEmail,
    setPermitYear,
    setPermitYearsLoading,
    setPermitYears,
    setPermitNumber,
    addFacilityUsage,
    removeFacilityUsage,
    updateFacilityUsage,
    setFacilityUsages,
    setActivitiesLoading,
    setActivities,
    setAreasLoading,
    setAreas,
    setFacilitiesLoading,
    setFacilities,
    setPersistentStorageChecked,
    setPermitNumberServerValidationError,
    setPermitNumberServerValidationErrorMessage,
    setShouldAutosave,
    setPendingAsyncRequest,
    setPerformingInitialLoad,
    setZeroFacilityUsagesReport,
    setIsZeroFacilityUsagesReportSubmission
};